export const USER_SESSION_INTERNAL_DATA = '__USER_SESSION_DATA__'
